// See docs/blocks/section-header.md#heading-levels
export const getSectionHeadingLevels = ({
  hasHero = true,
  isFirstSectionHeader = false,
  hasHeading,
}: {
  hasHero?: boolean
  isFirstSectionHeader?: boolean
  hasHeading: boolean
}): { headingLevel: 'h1' | 'h2'; eyebrowLevel: 'h2' | 'p' } => ({
  headingLevel: !hasHero && isFirstSectionHeader && hasHeading ? 'h1' : 'h2',
  eyebrowLevel: hasHeading ? 'p' : 'h2',
})
